__turbopack_context__.v({
  "PhoneBarMobile": "MobileMenu-module-scss-module__Mi-ODG__PhoneBarMobile",
  "mobileMenu": "MobileMenu-module-scss-module__Mi-ODG__mobileMenu",
  "mobileMenuInner": "MobileMenu-module-scss-module__Mi-ODG__mobileMenuInner",
});
